module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/2024-join-opt-online-only-f898aef384b2dee9b146692695a4f530.png";